import React from 'react';
import { Row, Col, Button, Typography } from 'antd';
import { motion } from 'framer-motion';
import './HeroSection.css';

const { Title, Paragraph } = Typography;

const HeroSection = () => {
  return (
    <div className="hero-section">
      <Row gutter={[16, 16]} align="middle" style={{ minHeight: '80vh' }}>
        <Col xs={24} md={12}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Title level={1}  >
                 Your Partner in PHC Compliance
            </Title>
            <Paragraph className="hero-text">
              We provide expert consultancy to help healthcare facilities across Punjab meet the standards of the Punjab Health Commission.<br/> From documentation to inspection readiness, we guide you every step of the way professionally, reliably, and efficiently.
            </Paragraph>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <a href='/services'> <Button type="primary" size="large"> Our Services</Button></a>
            </motion.div>
          </motion.div>
        </Col>
        <Col xs={24} md={12}>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="hero-image">34r
              <iframe src="https://player.vimeo.com/video/1119170428?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style={{position:'absolute',top:'0',left:'0',width:'100%',height:'100%'}} title="Prime Health Care Consultancy | PHC Registration, Licensing &amp; Compliance Services in Punjab"></iframe>
              
            </div>
          </motion.div>
        </Col>
      </Row>
    </div>
  );
};

export default HeroSection;